import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4><a parentName="h4" {...{
        "href": "/foundations/color"
      }}>{`Color`}</a></h4>
    <p>{`How to work with color modes and themes, and how to apply color to GitHub interfaces.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/foundations/responsive"
      }}>{`Responsive`}</a></h4>
    <p>{`How to create responsive interfaces for GitHub.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/foundations/css-utilitiesw"
      }}>{`CSS Utilities`}</a></h4>
    <p>{`How to use Primer CSS utilities to build interfaces.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/foundations/layout"
      }}>{`Layout`}</a></h4>
    <p>{`How to create layouts to provide consistent, accessible, and responsive experiences.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/foundations/typography"
      }}>{`Typography`}</a></h4>
    <p>{`How to use and apply typography to GitHub interfaces.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      